import { render, staticRenderFns } from "./TabGeneraDocumento.vue?vue&type=template&id=d667ec42&scoped=true"
import script from "./TabGeneraDocumento.vue?vue&type=script&lang=js"
export * from "./TabGeneraDocumento.vue?vue&type=script&lang=js"
import style0 from "./TabGeneraDocumento.vue?vue&type=style&index=0&id=d667ec42&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d667ec42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d667ec42')) {
      api.createRecord('d667ec42', component.options)
    } else {
      api.reload('d667ec42', component.options)
    }
    module.hot.accept("./TabGeneraDocumento.vue?vue&type=template&id=d667ec42&scoped=true", function () {
      api.rerender('d667ec42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/formalizacionactas/TabGeneraDocumento.vue"
export default component.exports